import { getAddressKeysByType, useAddressFormatter } from 'modules/domain/logisticsKR/utils'
import { FC } from 'react'
import {
  LogisticsKRLoadingWarehouse,
  LogisticsKRUnloadingWarehouse,
  isUnloadingWarehouse,
} from 'views/pages/LogisticsKR/types'

interface Props {
  warehouse: LogisticsKRLoadingWarehouse | LogisticsKRUnloadingWarehouse
}

export const WarehouseParams: FC<Props> = ({ warehouse }) => {
  const addressKeys: string[] = getAddressKeysByType(!isUnloadingWarehouse(warehouse))
  const formatter = useAddressFormatter()

  const addressWarehouseInfo = formatter(warehouse, addressKeys).join(', ')

  return <div>{addressWarehouseInfo}</div>
}
